import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WarrantyCoverageWithLiabilityInfo } from '../coverage-card/coverage-card.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-coverage-liability-limit',
  templateUrl: './coverage-liability-limit.component.html',
  standalone: false,
})
export class CoverageLiabilityLimitComponent {
  @Input() isLiabilityPerClaim = false;
  @Input() item: WarrantyCoverageWithLiabilityInfo | null = null;
}
